
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

const useHealthCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // ✅ Prevent infinite redirect loop
    if (window.location.pathname === "/something-went-wrong") return;

    const checkHealth = async () => {
      console.log("🔁 Health check triggered...");

      try {
        const res = await timeoutFetch("https://biometric-staging-backend.caprover-testing.mtechub.com/health", {
          method: "GET",
        });

        const contentType = res.headers.get("content-type");
        console.log("📥 Health API response:", res.status, contentType);

        if (!res.ok) {
        //   console.warn("❌ res.ok is false. Server responded with non-200.");
        //   toast.error("Server issue. Redirecting...");
        //   navigate("/something-went-wrong");
        //   return;
        throw new Error('💥 This is a forced error!');
        }

        if (contentType && contentType.includes("text/html")) {
          console.warn("❌ Response is HTML — likely a misrouted or broken endpoint.");
          toast.error("Received invalid response from server.");
          navigate("/something-went-wrong");
          return;
        }

        console.log("✅ Backend health is OK");

      } catch (err) {
        console.error("🔥 Health check fetch failed:", err.message);
        toast.error("Backend unreachable. Redirecting...");
        navigate("/something-went-wrong");
      }
    };

    checkHealth();
  }, [navigate]);
};

export default useHealthCheck;

// ✅ Add timeout to avoid hanging forever
const timeoutFetch = (url, options, timeout = 7000) => {
  return Promise.race([
    fetch(url, options),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Timeout")), timeout)
    ),
  ]);
};




// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-hot-toast";

// const useHealthCheck = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     const checkHealth = async () => {
//       console.log("🔁 Health check triggered...");

//       try {
//         const res = await fetch("https://biometric-staging-backend.caprover-testing.mtechub.com/health", {
//           method: "GET",
//         });

//         const contentType = res.headers.get("content-type");
//         console.log("📥 Health API response:", res.status, contentType);

//         if (!res.ok) {
//           console.warn("❌ res.ok is false. Server responded with non-200.");
//           toast.error("Server issue. Redirecting...");
//           navigate("/something-went-wrong");
//           return;
//         }

//         if (contentType && contentType.includes("text/html")) {
//           console.warn("❌ Response is HTML — likely a misrouted or broken endpoint.");
//           toast.error("Received invalid response from server.");
//           navigate("/something-went-wrong");
//           return;
//         }

//         console.log("✅ Backend health is OK");

//       } catch (err) {
//         console.error("🔥 Health check fetch failed:", err.message);
//         toast.error("Backend unreachable. Redirecting...");
//         navigate("/something-went-wrong");
//       }
//     };

//     checkHealth(); // run immediately on mount

//     // const interval = setInterval(checkHealth, 30000);
//     // return () => clearInterval(interval); // clean up
//   }, [navigate]);
// };

// export default useHealthCheck;


